import { apiClient } from './apiClient';

export type Course = {
    id: string;
    title: string;
    description: string;
    instructor: string;
    duration: string;
    lessons_count: number;
    level: 'Beginner' | 'Intermediate' | 'Advanced';
    category: string;
    thumbnail: string;
    course_type: 'bootcamp' | 'coaching';
};

export type Lesson = {
    id: string;
    title: string;
    duration: string;
    content: string;
    video_url: string;
    has_quiz: boolean;
    order: number;
};

type CoursesResponse = {
    courses: Course[];
    count: number;
    next: string | null;
    previous: string | null;
};

export async function getCourses(courseType?: 'bootcamp' | 'coaching'): Promise<CoursesResponse> {
    const url = courseType
        ? `/api/courses/?course_type=${courseType}`
        : '/api/courses/';

    const response = await apiClient.get(url);
    return {
        courses: response.data.results,
        count: response.data.count,
        next: response.data.next,
        previous: response.data.previous,
    };
}

export async function getLessons(courseId: string): Promise<Lesson[]> {
    const response = await apiClient.get(`/api/courses/${courseId}/lessons/`);
    return response.data;
}

export type QuizQuestion = {
    id: string;
    type: 'mcq' | 'text';
    question: string;
    options?: string[];
    correct_answer: string;
    explanation: string;
};

export type Quiz = {
    id: string;
    title: string;
    description: string;
    course_id?: string;
    questions: QuizQuestion[];
    difficulty: 'Easy' | 'Medium' | 'Hard';
    time_limit: number;
    passing_score: number;
};

export async function getQuizzes(courseId: string): Promise<Quiz[]> {
    const response = await apiClient.get(`/api/courses/${courseId}/quizzes/`);
    return response.data;
}
